import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './misha.css';

function RedirectToExternal() {
  useEffect(() => {
    window.location.href = 'https://rjrapcore.bandcamp.com/';
  }, []);

  return null; // No UI, just the redirection
}

function App() {
  return (
    <div className="App b">
      <Router>
        <Routes>
          <Route path="/" element={<RedirectToExternal />} />
        </Routes>
      </Router>

      {/* <Layout /> */}
    </div>
  );
}

export default App;
